import getTrafficEstimation from '@bingads-webui-campaign-legacy/budget/shared/getTrafficEstimation';
import { bidSuggestionOpFormatter, budgetSuggestionOpFormatter } from '@bingads-webui-campaign-legacy/budget/shared/bidBudgetSuggestionFormatter';

const bidSuggestionEndpoint = '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.CampaignTrafficEstimateWithSuggestedBid';
const budgetSuggestionEndpoint = '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.GetEstimatedBudgetByCampaigns';

function getSuggestion(params, callbacks, options, timestamp, isBid) {
  const endpoint = isBid ? bidSuggestionEndpoint : budgetSuggestionEndpoint;
  const formatter = isBid ? bidSuggestionOpFormatter : budgetSuggestionOpFormatter;

  return getTrafficEstimation(params, callbacks, options, endpoint, formatter, timestamp);
}

export function getBidSuggestion(params, callbacks, options, timestamp) {
  return getSuggestion(params, callbacks, options, timestamp, true);
}

export function getBudgetSuggestion(params, callbacks, options, timestamp) {
  return getSuggestion(params, callbacks, options, timestamp, false);
}
